import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=f3f1ea12&scoped=true"
import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=f3f1ea12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f1ea12",
  null
  
)

export default component.exports